import { render, staticRenderFns } from "./newCompra.vue?vue&type=template&id=74a82723"
import script from "./newCompra.vue?vue&type=script&lang=js"
export * from "./newCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports